exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.col-price--total {white-space: nowrap}\n.col-price {white-space: nowrap}\n", ""]);

// exports
